import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-45" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-46" data-mp="9vz8armq81l">
        <div className="mx-auto max-w-3xl text-center" data-id="element-47" data-mp="58z5tzn9cmbo">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-48" data-mp="57ebob4uv5ec">
            La différence ARTS PRÊT™
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-49" data-mp="3rg72mdk43kw3">
            Passez du statut de prof débordé à celui de{' '}
            <span className="italic text-brand" data-id="element-50" data-mp="3ifr3thebd1xk">guide serein.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-51" data-mp="3ihv7by8avyxb">
            Donnez un rythme clair à vos séances, boostez la confiance créative
            de vos élèves et retrouvez le plaisir d&apos;enseigner.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-ink/10 bg-white sm:grid-cols-3" data-id="element-52" data-mp="1j9ugm2s6zpiq">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-ink/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-53" data-mp="1sznigc2j8q9s" data-mpi={index}>
              <dt className="sr-only" data-id="element-54" data-mp="wapo2uyp2ud5">{stat.label}</dt>
              <dd data-id="element-55" data-mp="wc0z9fugz4ea">
                <span className="block font-display text-3xl font-black text-brand" data-id="element-56" data-mp="wcsn24htrxu0">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/50" data-id="element-57" data-mp="15auv33zz7qqs">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-58" data-mp="2gphw2vuoeiv3">
          <div className="grid md:grid-cols-2" data-id="element-59" data-mp="2orsasv1b6tou">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-60" data-mp="2oqz6e0ptog9v">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-ink/40" data-id="element-61" data-mp="2ss2m8n7vecb3">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-62" data-mp="2xsqgrivb5ba2" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-ink/45" data-id="element-63" data-mp="32q8pp99brqi2">
                Le coût de l&apos;improvisation
              </span>
              <h3 className="mt-3 font-display text-2xl font-bold tracking-wide text-ink" data-id="element-64" data-mp="2a1l0x3pdaizr">
                AVANT
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-ink/55" data-id="element-65" data-mp="2ezurt2426xfk">
                Ce que la planification à partir de zéro vole silencieusement à
                votre semaine.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-66" data-mp="1mciap7go3htn">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-full bg-white/70 px-4 py-3 text-sm text-ink/65" data-id="element-67" data-mp="1ra0kf02ie12p">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-68" data-mp="1euka5sggrh2k" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-69" data-mp="10tzuv69rc3dt">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand text-white" data-id="element-70" data-mp="10vkqkz7t5sd9">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-71" data-mp="r355vu54mpoo" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-72" data-mp="m4tu3dv9u53t">
                Le système ARTS PRÊT™
              </span>
              <h3 className="mt-3 font-display text-2xl font-bold tracking-wide text-ink" data-id="element-73" data-mp="h4pdzoy9zce4">
                AVEC ARTS PRÊT™
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-ink/55" data-id="element-74" data-mp="11utd69adh7k4">
                Entrez dans chaque cours avec un plan structuré et clair.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-75" data-mp="16vqvqmzao3m5">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-brand-light/60 px-4 py-3 text-sm font-medium text-ink" data-id="element-76" data-mp="t058ak8plrvu">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-77" data-mp="j64uzv39xgc1" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-ink/5 bg-cream/60 px-6 py-4 text-center text-xs text-ink/50" data-id="element-78" data-mp="e5h55cqs75je">
            Un système complet pour planifier moins et enseigner avec plus de
            sens.
          </p>
        </div>
      </div>
    </section>;
}